import {Component, OnInit, Input, EventEmitter, Output} from '@angular/core';
import {FormGroup, FormBuilder, Validators, AbstractControl, FormControl} from "@angular/forms";
import {AuthService} from "../shared/security/auth.service";
import {Cpu} from "../shared/model/cpu";
import {CpusService} from "../shared/model/cpus.service";
import {TranslateService} from "@ngx-translate/core";

@Component({
    selector: 'app-cpu-detail',
    templateUrl: './cpu-detail.component.html',
    styleUrls: ['./cpu-detail.component.css']
})
export class CpuDetailComponent implements OnInit {
    @Input()
    cpu: Cpu;

    @Input()
    dbPath: string;     // link to Firebase database path location (<dbLocation>/clubId/fieldId)

    @Output()
    onDetailCpuDone = new EventEmitter<boolean>();

    myForm: FormGroup;

    location: string;
    description: string;
    address: string;
    installationDate: string;

    isSaved: boolean = false;
    hasError: boolean = false;
    message: string = "";

    public visibleDetailCpu = false;
    private visibleDetailCpuAnimate = false;

    constructor(private fb: FormBuilder, private cpusService: CpusService, private authService: AuthService, private translate: TranslateService) {
        this.myForm = fb.group({
            'location': ['', Validators.compose([Validators.required, Validators.minLength(3)])],
            'description': ['', Validators.compose([Validators.required, Validators.minLength(6)])],
            'installationDate': ['', Validators.compose([Validators.required, Validators.minLength(6)])]
        });
    }

    formDone(done: boolean) {
        this.onDetailCpuDone.emit(false);  // hide modal add screen
    }

    ngOnInit() {
        //console.log("ngOnInit: CpuDetailComponent");
        //console.log("dbPath ngOnInit(): ", this.dbPath);
        this.isSaved = false;

        this.location = this.cpu.location;
        this.description = this.cpu.description;
        this.address = this.cpu.address;
        this.installationDate = this.cpu.installationDate;

        this.show();
    }

    ngOnChanges() {
    }

    public show(): void {
        this.visibleDetailCpu = true;
        setTimeout(() => this.visibleDetailCpuAnimate = true, 1000);
    }

    public hide(): void {
        this.visibleDetailCpuAnimate = false;
        setTimeout(() => this.visibleDetailCpu = false, 300);
    }

    public save() {
      let retVal = this.cpusService.updateCpu(this.dbPath, this.location, this.description, this.address, this.installationDate);
      this.translate.get('s.cpuedit')
        .subscribe((res: string) => {
          this.message = res;
          this.isSaved = true;
        });
    }

}
